import LoginScreen from "auth/LoginScreen";
import { useOrganizationContext } from "context/OrganisationContext";
import { useRoomTemplateLoginPageContext } from "context/RoomTemplateContext";
import { useLocalizationContext } from "localization/LocalizationProvider";

import { Locales } from "localization/types";
import queryString from "query-string";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { DEFAULT_LOCALE } from "../constants/index";

const LoginScreenWrapper: React.FC = ({ children }) => {
	const { value: roomTemplate, loading } = useRoomTemplateLoginPageContext();
	const navigate = useNavigate();

	const org = useOrganizationContext();
	const { updateTranslations } = useLocalizationContext();
	const location = useLocation();
	const langParam = (queryString.parse(location.search)?.lang || "") as string;
	let requestedLanguage = roomTemplate
		? roomTemplate?.supportedLocales?.includes(langParam as string)
			? langParam.toLowerCase()
			: roomTemplate?.supportedLocales[0]
		: DEFAULT_LOCALE;

	useEffect(() => {
		const searchParams = new URLSearchParams(location.search);
		const passwordlessToken = queryString.parse(location.search)?.token as string;
		const isPasswordlessLogin = queryString.parse(location.search)?.p === "1";

		if (requestedLanguage) searchParams.set("lang", requestedLanguage);
		if (passwordlessToken) searchParams.set("token", passwordlessToken);
		if (isPasswordlessLogin) searchParams.set("p", "1");

		const pathName = `${location.pathname}?${searchParams.toString()}`;

		if (requestedLanguage && roomTemplate) {
			updateTranslations({
				locale: requestedLanguage as Locales,
				roomTemplateId: roomTemplate._id,
				organizationId: roomTemplate.organization,
			});
			navigate(pathName, { replace: true });
		}
	}, [
		updateTranslations,
		roomTemplate,
		roomTemplate?.supportedLocales,
		requestedLanguage,
		navigate,
		location.pathname,
		location.search,
	]);

	const loginContent = roomTemplate?.loginContent || {};
	if (org.loading === false && loading === false) {
		return <LoginScreen loginContent={loginContent} orgSlug={org.value?.slug} roomTemplateId={roomTemplate?._id} />;
	}
	return null;
};

export default LoginScreenWrapper;
